import { createStyles, makeStyles, Theme } from '@material-ui/core';
import { fileInfoType } from 'api/file/interfaces/get-file';
import { KBLinks } from 'features/constants';
import React, { FC } from 'react';
import { CertificationFormData } from '../types';

import PageHeader from 'ui-kit/components/headers/PageHeader';
import LoadingSpinner from 'ui-kit/components/LoadingSpinner';
import ContentContainer from 'ui-kit/components/utility/ContentContainer';
import { AsyncStatusType } from '../constants';
import CertificationForm from './CertificationForm';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    formContainer: {
      backgroundColor: theme.palette.common.white,
      borderRadius: theme.spacing(1),
      padding: theme.spacing(1, 3, 3, 3),
      marginBottom: theme.spacing(3),
    },
  }),
);

interface CertifyReportContentProps {
  status: AsyncStatusType;
  fileData?: fileInfoType | null;
  menuCollapsed?: boolean;
  formSubmitted?: boolean;
  formData: CertificationFormData;
  onFormChange: (field: string, value: string | boolean) => void;
  onBatchFormChange?: (updates: Partial<CertificationFormData>) => void;
  onFormSubmissionComplete: () => void;
  isReadOnly?: boolean;
}

const CertifyReportContent: FC<CertifyReportContentProps> = ({
  formSubmitted = false,
  formData,
  onFormChange,
  onBatchFormChange,
  status,
  onFormSubmissionComplete,
  isReadOnly = false,
}) => {
  const classes = useStyles();

  return (
    <div
      style={{ pointerEvents: isReadOnly ? 'none' : 'auto', opacity: isReadOnly ? 0.6 : 1 }}
      tabIndex={isReadOnly ? -1 : undefined}
      onKeyDown={(e) => isReadOnly && e.preventDefault()}
    >
      <ContentContainer fullWidth mTop="0">
        <LoadingSpinner status={status} variant="linear" />
        <PageHeader
          title="Certify & Generate Report"
          subtitle="Complete all required fields below and certify your authorization before generating your report. After clicking generate, your report will be processed and converted to XML format. You will then be redirected to a summary screen where you can review and download your completed report."
          menuItems={[
            {
              label: 'Knowledge Base',
              link: KBLinks.fincenReport,
            },
          ]}
          data-testid="fincen-certify-page-header"
        />

        <div className={classes.formContainer} data-testid="fincen-certify-form-container">
          <CertificationForm
            submitted={formSubmitted}
            onChange={onFormChange}
            onBatchChange={onBatchFormChange}
            formData={formData}
            onFormSubmissionComplete={onFormSubmissionComplete}
          />
        </div>
      </ContentContainer>
    </div>
  );
};
export default React.memo(CertifyReportContent);
